<script lang="ts">
  export let mainHeadline: string = '';
  export let subHeadline: string = '';
</script>

<div class="space-y-4 text-center md:mb-4 md:text-left">
  <h2
    class="!font-bold leading-[1.2] text-[var(--color-primary)] lg:text-[48px] xl:pr-14"
  >
    {@html mainHeadline}
  </h2>
  <h3
    class="text-2xl !font-bold leading-[1.25] text-[var(--color-accent)] lg:text-[32px]"
  >
    {@html subHeadline}
  </h3>
</div>
